export default __webpack_public_path__ + "static/media/autoroute.8c53e80d.jpg";